module.exports = __webpack_public_path__ + "img/edge_activites_visites.18fbc92b.svg";